// FRAML Customer Aggregate Detail — action types and creators
// Phase-2: FIN-11398 data layer (slice + saga + service)

// --- Aggregate ---
// FIN-12885 — per-alert Resolve: auto-assign to the acting user, then transition to
// NO_ISSUE (the strict transition table has no UNASSIGNED→NO_ISSUE edge), then refetch.
export const RESOLVE_FRAML_ALERT = 'RESOLVE_FRAML_ALERT';
export const RESOLVE_FRAML_ALERT_SUCCESS = 'RESOLVE_FRAML_ALERT_SUCCESS';
export const RESOLVE_FRAML_ALERT_FAIL = 'RESOLVE_FRAML_ALERT_FAIL';

export const FETCH_FRAML_CUSTOMER_AGGREGATE = 'FETCH_FRAML_CUSTOMER_AGGREGATE';
export const FETCH_FRAML_CUSTOMER_AGGREGATE_SUCCESS =
  'FETCH_FRAML_CUSTOMER_AGGREGATE_SUCCESS';
export const FETCH_FRAML_CUSTOMER_AGGREGATE_FAIL =
  'FETCH_FRAML_CUSTOMER_AGGREGATE_FAIL';

// --- Score History ---
export const FETCH_FRAML_CUSTOMER_SCORE_HISTORY =
  'FETCH_FRAML_CUSTOMER_SCORE_HISTORY';
export const FETCH_FRAML_CUSTOMER_SCORE_HISTORY_SUCCESS =
  'FETCH_FRAML_CUSTOMER_SCORE_HISTORY_SUCCESS';
export const FETCH_FRAML_CUSTOMER_SCORE_HISTORY_FAIL =
  'FETCH_FRAML_CUSTOMER_SCORE_HISTORY_FAIL';

// --- Alerts ---
export const FETCH_FRAML_CUSTOMER_ALERTS = 'FETCH_FRAML_CUSTOMER_ALERTS';
export const FETCH_FRAML_CUSTOMER_ALERTS_SUCCESS =
  'FETCH_FRAML_CUSTOMER_ALERTS_SUCCESS';
export const FETCH_FRAML_CUSTOMER_ALERTS_FAIL =
  'FETCH_FRAML_CUSTOMER_ALERTS_FAIL';

// --- Risk Factors ---
export const FETCH_FRAML_CUSTOMER_RISK_FACTORS =
  'FETCH_FRAML_CUSTOMER_RISK_FACTORS';
export const FETCH_FRAML_CUSTOMER_RISK_FACTORS_SUCCESS =
  'FETCH_FRAML_CUSTOMER_RISK_FACTORS_SUCCESS';
export const FETCH_FRAML_CUSTOMER_RISK_FACTORS_FAIL =
  'FETCH_FRAML_CUSTOMER_RISK_FACTORS_FAIL';

// --- Customer Details (party identity) ---
export const FETCH_FRAML_CUSTOMER_DETAILS = 'FETCH_FRAML_CUSTOMER_DETAILS';
export const FETCH_FRAML_CUSTOMER_DETAILS_SUCCESS =
  'FETCH_FRAML_CUSTOMER_DETAILS_SUCCESS';
export const FETCH_FRAML_CUSTOMER_DETAILS_FAIL =
  'FETCH_FRAML_CUSTOMER_DETAILS_FAIL';

// --- Associated Customers (linked customers) ---
export const FETCH_FRAML_ASSOCIATED_CUSTOMERS =
  'FETCH_FRAML_ASSOCIATED_CUSTOMERS';
export const FETCH_FRAML_ASSOCIATED_CUSTOMERS_SUCCESS =
  'FETCH_FRAML_ASSOCIATED_CUSTOMERS_SUCCESS';
export const FETCH_FRAML_ASSOCIATED_CUSTOMERS_FAIL =
  'FETCH_FRAML_ASSOCIATED_CUSTOMERS_FAIL';

// --- Associated Accounts ---
export const FETCH_FRAML_ASSOCIATED_ACCOUNTS =
  'FETCH_FRAML_ASSOCIATED_ACCOUNTS';
export const FETCH_FRAML_ASSOCIATED_ACCOUNTS_SUCCESS =
  'FETCH_FRAML_ASSOCIATED_ACCOUNTS_SUCCESS';
export const FETCH_FRAML_ASSOCIATED_ACCOUNTS_FAIL =
  'FETCH_FRAML_ASSOCIATED_ACCOUNTS_FAIL';

// --- Similar KYC ---
export const FETCH_FRAML_SIMILAR_KYC = 'FETCH_FRAML_SIMILAR_KYC';
export const FETCH_FRAML_SIMILAR_KYC_SUCCESS =
  'FETCH_FRAML_SIMILAR_KYC_SUCCESS';
export const FETCH_FRAML_SIMILAR_KYC_FAIL = 'FETCH_FRAML_SIMILAR_KYC_FAIL';

// --- Action creators ---
export const fetchFramlCustomerAggregate = (customerKey) => ({
  type: FETCH_FRAML_CUSTOMER_AGGREGATE,
  payload: customerKey
});

export const fetchFramlCustomerAggregateSuccess = (data) => ({
  type: FETCH_FRAML_CUSTOMER_AGGREGATE_SUCCESS,
  payload: data
});

export const fetchFramlCustomerAggregateFail = (message) => ({
  type: FETCH_FRAML_CUSTOMER_AGGREGATE_FAIL,
  payload: { message }
});

export const fetchFramlCustomerScoreHistory = (customerKey) => ({
  type: FETCH_FRAML_CUSTOMER_SCORE_HISTORY,
  payload: customerKey
});

export const fetchFramlCustomerScoreHistorySuccess = (data) => ({
  type: FETCH_FRAML_CUSTOMER_SCORE_HISTORY_SUCCESS,
  payload: data
});

export const fetchFramlCustomerScoreHistoryFail = (message) => ({
  type: FETCH_FRAML_CUSTOMER_SCORE_HISTORY_FAIL,
  payload: { message }
});

export const fetchFramlCustomerAlerts = (customerKey) => ({
  type: FETCH_FRAML_CUSTOMER_ALERTS,
  payload: customerKey
});

export const fetchFramlCustomerAlertsSuccess = (data) => ({
  type: FETCH_FRAML_CUSTOMER_ALERTS_SUCCESS,
  payload: data
});

export const fetchFramlCustomerAlertsFail = (message) => ({
  type: FETCH_FRAML_CUSTOMER_ALERTS_FAIL,
  payload: { message }
});

export const fetchFramlCustomerRiskFactors = (customerKey) => ({
  type: FETCH_FRAML_CUSTOMER_RISK_FACTORS,
  payload: customerKey
});

export const fetchFramlCustomerRiskFactorsSuccess = (data) => ({
  type: FETCH_FRAML_CUSTOMER_RISK_FACTORS_SUCCESS,
  payload: data
});

export const fetchFramlCustomerRiskFactorsFail = (message) => ({
  type: FETCH_FRAML_CUSTOMER_RISK_FACTORS_FAIL,
  payload: { message }
});

export const fetchFramlCustomerDetails = (customerKey) => ({
  type: FETCH_FRAML_CUSTOMER_DETAILS,
  payload: customerKey
});

export const fetchFramlCustomerDetailsSuccess = (data) => ({
  type: FETCH_FRAML_CUSTOMER_DETAILS_SUCCESS,
  payload: data
});

export const fetchFramlCustomerDetailsFail = (message) => ({
  type: FETCH_FRAML_CUSTOMER_DETAILS_FAIL,
  payload: { message }
});

// --- Associated Customers ---
export const fetchFramlAssociatedCustomers = (customerKey) => ({
  type: FETCH_FRAML_ASSOCIATED_CUSTOMERS,
  payload: customerKey
});

export const fetchFramlAssociatedCustomersSuccess = (data) => ({
  type: FETCH_FRAML_ASSOCIATED_CUSTOMERS_SUCCESS,
  payload: data
});

export const fetchFramlAssociatedCustomersFail = (message) => ({
  type: FETCH_FRAML_ASSOCIATED_CUSTOMERS_FAIL,
  payload: { message }
});

// --- Associated Accounts ---
export const fetchFramlAssociatedAccounts = (customerKey) => ({
  type: FETCH_FRAML_ASSOCIATED_ACCOUNTS,
  payload: customerKey
});

export const fetchFramlAssociatedAccountsSuccess = (data) => ({
  type: FETCH_FRAML_ASSOCIATED_ACCOUNTS_SUCCESS,
  payload: data
});

export const fetchFramlAssociatedAccountsFail = (message) => ({
  type: FETCH_FRAML_ASSOCIATED_ACCOUNTS_FAIL,
  payload: { message }
});

// --- Similar KYC ---
// FIN-12966 — carries { limit, offset } so Similar KYC pages server-side.
export const fetchFramlSimilarKyc = (customerKey, paging) => ({
  type: FETCH_FRAML_SIMILAR_KYC,
  payload: customerKey,
  paging
});

export const fetchFramlSimilarKycSuccess = (data) => ({
  type: FETCH_FRAML_SIMILAR_KYC_SUCCESS,
  payload: data
});

export const fetchFramlSimilarKycFail = (message) => ({
  type: FETCH_FRAML_SIMILAR_KYC_FAIL,
  payload: { message }
});

// FIN-12885
export const resolveFramlAlert = ({ customerKey, alertId, userId }) => ({
  type: RESOLVE_FRAML_ALERT,
  payload: { customerKey, alertId, userId }
});

export const resolveFramlAlertSuccess = ({ alertId }) => ({
  type: RESOLVE_FRAML_ALERT_SUCCESS,
  payload: { alertId }
});

export const resolveFramlAlertFail = ({ message }) => ({
  type: RESOLVE_FRAML_ALERT_FAIL,
  payload: { message }
});
